import $axios from "@/common/http"  //导入封装的axios

export function login(code:any){
    return $axios.post("/login?authCode="+code)
}

export function loginout(token:any){
    return $axios.get("/loginout",{headers:{token}})
}

export function selectUserInfo(token:any){
    return $axios.get("/user/selectUserInfo",{headers:{token}})
}

export function updateUserInfo(data:any,token:any){
    return $axios.post("/user/updateUserInfo" ,data,{headers:{token}})
}
